<template>
  <div class="right_block courses">
    <CourseCard
      v-if="isAuth && $route.name === 'course-info_id'"
      :course-info="courseInfo"
      :courses-list="coursesList"
      :stages-list="stagesList"
      @start="(stage) => $emit('start', stage)"
    />

    <UserCoursesList :courses-list="coursesList" />
  </div>
</template>

<script>
import UserCoursesList from '@/components/right_block/UserCoursesList'
import CourseCard from '@/components/right_block/CourseCard'

export default {
  components: {
    UserCoursesList,
    CourseCard
  },
  props: {
    courseInfo: {
      default: () => {},
      type: Object
    },
    stagesList: {
      default: () => [],
      type: Array
    }
  },
  computed: {
    isAuth() {
      return this.$store.state.auth.auth
    },
    coursesList() {
      return this.$store.state.courses.userRightCoursesList.courses
    }
  },
  methods: {
    loadData() {
      this.$axios2
        .get('courses')
        .then((resp) => {
          this.$store.commit('setUserRightCoursesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>
